import { cardTypes, IPaymentCard } from '../store';

export function usePaymentCardType(paymentCard: IPaymentCard) {
  return paymentCard.virtualConverted
    ? cardTypes.VIRTUAL_CONVERTED
    : paymentCard.physical
      ? cardTypes.PHYSICAL
      : cardTypes.VIRTUAL;
}
